const PENDING_CUSTOMER_AUTH_VERSION = 1

export function pendingCustomerAuthStorageKey(vendorToken, draftPublicId) {
  return `gspress:customer-auth-pending:${vendorToken}:${draftPublicId}`
}

function sessionStorageAvailable() {
  if (typeof window === 'undefined') return false

  try {
    return Boolean(window.sessionStorage)
  } catch {
    return false
  }
}

function validPendingCustomerAuth(value, vendorToken, draftPublicId) {
  const phase = value?.phase || 'pending'
  const validRequiredPhase = phase === 'required' &&
    typeof value?.email === 'string' &&
    value?.handoffToken === null &&
    value?.requestedAt === null &&
    value?.expiresAt === null
  const validPendingPhase = phase === 'pending' &&
    typeof value?.email === 'string' &&
    value.email.length > 0 &&
    (value?.handoffToken === null || typeof value?.handoffToken === 'string') &&
    Number.isFinite(value?.requestedAt) &&
    Number.isFinite(value?.expiresAt)

  return Boolean(
    value &&
    value.version === PENDING_CUSTOMER_AUTH_VERSION &&
    value.vendorToken === vendorToken &&
    value.draftPublicId === draftPublicId &&
    (validRequiredPhase || validPendingPhase) &&
    (value.reviewOrigin === null ||
      value.reviewOrigin === 'guided' ||
      value.reviewOrigin === 'manual' ||
      value.reviewOrigin === 'manual_entry')
  )
}

export function readPendingCustomerAuth(vendorToken, draftPublicId) {
  if (!sessionStorageAvailable() || !vendorToken || !draftPublicId) return null

  try {
    const value = JSON.parse(
      window.sessionStorage.getItem(pendingCustomerAuthStorageKey(vendorToken, draftPublicId))
    )
    return validPendingCustomerAuth(value, vendorToken, draftPublicId)
      ? { ...value, phase: value.phase || 'pending' }
      : null
  } catch {
    return null
  }
}

export function writePendingCustomerAuth(vendorToken, draftPublicId, request) {
  if (!sessionStorageAvailable() || !vendorToken || !draftPublicId || !request) return null

  const value = {
    version: PENDING_CUSTOMER_AUTH_VERSION,
    vendorToken,
    draftPublicId,
    phase: request.phase || 'pending',
    email: request.email || '',
    reviewOrigin: request.reviewOrigin || null,
    handoffToken: request.handoffToken || null,
    requestedAt: request.requestedAt ?? null,
    expiresAt: request.expiresAt ?? null,
  }
  if (!validPendingCustomerAuth(value, vendorToken, draftPublicId)) return null

  try {
    window.sessionStorage.setItem(
      pendingCustomerAuthStorageKey(vendorToken, draftPublicId),
      JSON.stringify(value)
    )
    return value
  } catch {
    return null
  }
}

export function writeRequiredCustomerAuth(vendorToken, draftPublicId, reviewOrigin) {
  return writePendingCustomerAuth(vendorToken, draftPublicId, {
    phase: 'required',
    email: '',
    reviewOrigin: reviewOrigin || null,
    handoffToken: null,
    requestedAt: null,
    expiresAt: null,
  })
}

export function clearPendingCustomerAuth(vendorToken, draftPublicId) {
  if (!sessionStorageAvailable() || !vendorToken || !draftPublicId) return false

  try {
    window.sessionStorage.removeItem(pendingCustomerAuthStorageKey(vendorToken, draftPublicId))
    return true
  } catch {
    return false
  }
}
